import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IncluirEstatistica } from './types';

export const INITIAL_STATE: IncluirEstatistica = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IncluirEstatistica {
	return produce(state, draft => {
		switch (action.type) {
			case Types.INCLUIR_ESTATISTICA_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.INCLUIR_ESTATISTICA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.INCLUIR_ESTATISTICA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.INCLUIR_ESTATISTICA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
